import React from 'react'
import styles from './StoreFrontLayout.module.scss'
import StoreFrontLayoutHeader from './components/StoreFrontLayoutHeader'
import { Outlet } from 'react-router-dom'
import LandingPageFooter from '../../../layouts/public-layout-landing/components/Footer'

type Props = {}

const StoreFrontLayout: React.FC<Props> = (props: Props) => {
    return (
        <div className={styles.container}>
            <StoreFrontLayoutHeader />
            <Outlet />
            <LandingPageFooter />
        </div>
    )
}

export default StoreFrontLayout